<template>
    <single-select v-model="selectedLanguage" :options="languages"/>
</template>
<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import SingleSelect from './SingleSelect';
    import {LOCALE_SET} from '../../store/modules/locale';
    import _ from 'lodash';

    @Component({
        components: {SingleSelect}
    })
    export default class LanguagePicker extends Vue {
        get languages() {
            return _.map(this.$store.state.locale.labels, (label, code) => ({value: code, label: label}));
        }

        get selectedLanguage() {
            const locale = this.$store.state.locale;
            const selected = locale.selected;
            return {
                value: selected,
                label: locale.labels[selected],
            };
        }

        set selectedLanguage(language) {
            this.$store.dispatch(LOCALE_SET, language.value);
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/general/LanguagePicker.vue